export const lightTheme = {
    body: 'white',
    text: '#363537',
    toggleBorder: '#AD794B',
    background: 'transparent',
    
  }
  
  export const darkTheme = {
    body: 'black',
    text: '#FAFAFA',
    toggleBorder: '#AD794B',
    background: 'transparent',
  }